/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ step: NonNullable<unknown> }} Chat_Steps_Compacting_StepInputs */



/**
* | output |
* | --- |
* | "Compacting conversation to fit the model... (step {step})" |
*
* @param {Chat_Steps_Compacting_StepInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const chat_steps_compacting_step = /** @type {((inputs: Chat_Steps_Compacting_StepInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chat_Steps_Compacting_StepInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`Konversation wird komprimiert... (Schritt ${i?.step})`)
	return /** @type {LocalizedString} */ (`Compacting conversation to fit the model... (step ${i?.step})`)
});